import BezierEasing from 'bezier-easing'

export const CubicBezier = BezierEasing(.77,0,.175,1)
export const CSSTransitionTime = 400